import { Constants } from "appConstants";
import { HeadingDetails, Loading } from "components";
import { useEffect, useState } from "react";

import TermsDetailsMainPanel from "components/TermsDetailsMainPanel";
import useStandardToast from "hooks/useStandardToast";
import { Term } from "models/term/Term";
import { useParams } from "react-router-dom";
import { TermService } from "services/term";
import "../../styles.scss";

export default function TermDetails() {
	const { activeTermId } = useParams();
	const [activeTerm, setActiveTerm] = useState<Term | undefined>(undefined);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const { showErrorToast } = useStandardToast();

	const termService = new TermService();

	useEffect(() => {
		setIsLoading(true);
		termService
			.getById(activeTermId || "")
			.then((termResponse: Term) => {
				setActiveTerm(termResponse);
			})
			.catch(() => {
				showErrorToast(Constants.strings.errors.failedToGetTermDetails);
			})
			.finally(() => setIsLoading(false));
	}, [activeTermId]);

	return (
		<div className="tenant-page">
			{!isLoading ? (
				<>
					<HeadingDetails
						title={activeTerm?.type?.name || ""}
						showEditButton={false}
					/>
					<div className="details-content">
						<TermsDetailsMainPanel activeTerm={activeTerm} />
					</div>
				</>
			) : (
				<div className="tenant-list-loading">
					<Loading type="primary" size={75} />
				</div>
			)}
		</div>
	);
}
